import { useState } from 'react';

import HTMLToggler from '../HTMLToggler';

const InsertTwigInReact = ({ domElementId, shouldKeepElAfterUnmount = false }) => {
  const [domElement, setDomElement] = useState(null);

  return (
    <div ref={setDomElement}>
      {domElement && (
        <HTMLToggler
          elementId={domElementId}
          target={domElement}
          shouldKeepElAfterUnmount={shouldKeepElAfterUnmount}
        />
      )}
    </div>
  );
};

export default InsertTwigInReact;
